export function ConvertDateFormat (date){
        if (date instanceof Date && !isNaN(date)) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDateValue = `${year}-${month}-${day}`;
            return formattedDateValue
        } else {
            return ""
        }
}